<template>
  <Teleport to="#app">
    <div
      v-if="props.isShow && props.wsWork"
      class="dialog-mask"
      @click.self="close"
    >
      <div class="dialog-main">
        <div class="dituke">
          <img class="ditu" :src="props.wsWork.imageBlobUrl" alt="" />
        </div>
        <div class="close-btn" @click="close">
          <img :src="closeIcon" alt="" />
        </div>
        <div class="down" @click="downLoad">
          <img class="down-img" :src="faceSwapDown" alt="" />
        </div>
        <div v-if="!props.wsWork.hasFeedback" class="first-comment">
          <div class="item" @click="likeClick">
            <div class="animat" ref="likeRef"></div>
          </div>
          <div class="gedang"></div>
          <div class="item" @click="feedBack">
            <div class="animat" ref="dislikeRef"></div>
          </div>
        </div>
        <HlsVideoView
          :videoSrc="props.wsWork.fileData.fileUrl"
          v-if="props.wsWork.fileData.fileType !== 'image'"
        ></HlsVideoView>
        <div class="imgke" v-if="wsWork.fileData.fileType === 'image'">
          <img class="main-img" :src="props.wsWork.imageBlobUrl" alt="" />
        </div>
      </div>
    </div>
  </Teleport>
</template>
  
<script setup>
import { onMounted,
  getCurrentInstance,
  reactive,
  ref,
  computed,
  watchEffect,
  toRefs,
  defineProps,
  onBeforeUnmount, } from 'vue';
import like from '@/assets/animationJson/like.json';
import dislike from '@/assets/animationJson/dislike.json';
import lottie from 'lottie-web';
import HlsVideoView from './HlsVideoView.vue';
import { useFaceSwapTaskManager } from '@/stores/useFaceSwapTaskManager';
import { API } from '@/script/api';


let { $utility, $showFeedbackDialog, $showToast, $analytic, i18n } =
  getCurrentInstance().appContext.config.globalProperties;

// 下载icon
const faceSwapDown = $utility.assetImage('face_swap_down');
const closeIcon = $utility.assetImage('close_icon');
const props = defineProps({
  isShow: {
    type: Boolean,
    required: true,
    default: false,
  },
  wsWork: {
    type: Object,
    default: {},
  },
});
const emit = defineEmits(['update:isShow']);

const likeRef = ref(null);
const dislikeRef = ref(null);
let animatlike = null; 
let animatdislike = null; 
watchEffect(() => {
  animatlike = lottie.loadAnimation({
    container: likeRef.value,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData: like,
  });
  animatdislike = lottie.loadAnimation({
    container: dislikeRef.value,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData: dislike,
  });
});
/** 释放动画 */
onBeforeUnmount(() => {
  animatlike.destroy();
  animatdislike.destroy();
});
const close = () => {
  emit('update:isShow', false);
};
// 下载
const downLoad = () => {
  useFaceSwapTaskManager().downloadToLocal(props.wsWork);
};

const likeClick = () => {
  $showToast(i18n.global.t('choose.feedback'));
  $analytic.log('faceswap_created_like_tick', {
    category: props.wsWork.fileData.fileType == 'image' ? 'photo' : 'video',
    taskKey: props.wsWork.taskId,
  });
  setHasFeedback();
};
const setHasFeedback = () => {
  useFaceSwapTaskManager().setItemHasFeedback(props.wsWork.taskId);
};
const feedBack = () => {
  $analytic.log('faceswap_created_unlike_tick', {
    category: props.wsWork.fileData.fileType == 'image' ? 'photo' : 'video',
    taskKey: props.wsWork.taskId,
  });
  $showFeedbackDialog().then((result) => {
    const { confirm, selectedArray, moreMsg } = result;
    if (confirm) {
      setHasFeedback();
      $showToast(i18n.global.t('choose.feedback'));
      API.swapFeedBack({
        taskId: props.wsWork.taskId,
        category: selectedArray.join(','),
        content: moreMsg,
      }).then(() => {
        $analytic.log('faceswap_created_unlike_success', {
          category:
            props.wsWork.fileData.fileType == 'image' ? 'photo' : 'video',
          taskKey: props.wsWork.taskId,
        });
      });
    }
  });
};
</script>
  
<style scoped lang="scss">
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  backdrop-filter: blur(5px);

  .dialog-main {
    max-width: 1000px;
    max-height: 708px;
    position: relative;
    display: flex;
    margin: 0 140px;

    .down {
      cursor: pointer;
      position: absolute;
      top: 0px;
      right: -66px;
      width: 46px;
      height: 46px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 9px;
      z-index: 2;
      line-height: 46px;
      text-align: center;

      .down-img {
        width: 20px;
        height: 20px;
        color: #ffffff;
      }
    }

    .first-comment {
      cursor: pointer;
      position: absolute;
      top: 56px;
      right: -66px;
      width: 46px;
      height: 46px;
      background: #3a3433;
      border-radius: 9px;
      z-index: 2;
      line-height: 46px;
      text-align: center;
      width: 46px;
      height: 93px;

      .item {
        padding: 8px;

        .animat {
          width: 30px;
          height: 30px;
        }
      }

      .gedang {
        margin: 0 auto;
        width: 26px;
        height: 1px;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 1px;
      }
    }

    .dituke {
      overflow: hidden;
      position: absolute;
      width: 100%;
      height: 100%;

      .ditu {
        width: 100%;
        height: 100%;
        filter: blur(15px);
        transform: translate(0);
        z-index: 1;
      }
    }

    .imgke {
      transform: translate(0, 0);
      .main-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .close-btn {
    width: 46px;
    height: 46px;
    position: absolute;
    top: 0;
    right: -126px;
  }
}
@media screen and (max-width: 450px) {
  .dialog-mask {
    .dialog-main {
      width: 100%;
      height: calc(100% - 65px);
      position: relative;
      display: flex;
    margin: 0;

      margin-top: 65px;

      .down {
        cursor: pointer;
        position: absolute;
        top: -45px;
        right: 15px;
        width: 30px;
        height: 30px;
        background: rgba(255,255,255, 0.1);
        border-radius: 9px;
        z-index: 2;
        display: flex;
        justify-content: center;
        align-items: center;

        .down-img {
          width: 20px;
          height: 20px;
          color: #ffffff;
        }
      }

      .first-comment {
        cursor: pointer;
        position: absolute;
        top: -45px;
        right: 65px;
        width: 68px;
        height: 30px;
        background: #3a3433;
        border-radius: 9px;
        z-index: 2;
        line-height: 46px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        .item {
          padding: 2px;

          .animat {
            transform: translateY(-5px);
            width: 24px;
            height: 24px;
          }
        }

        .gedang {
          width: 1px;
          height: 13px;
          margin: 0;
          background: rgba(255, 255, 255, 0.5);
          border-radius: 1px;
        }
      }

      .dituke {
        overflow: hidden;
        position: absolute;
        width: 100%;
        height: 100%;

        .ditu {
          width: 100%;
          height: 100%;
          filter: blur(15px);
          transform: translate(0);
          z-index: 1;
        }
      }

      .imgke {
        transform: translate(0, 0);
        .main-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }

    .close-btn {
      width: 30px;
      height: 30px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      position: absolute;
      top: -45px;
      left: 15px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
  